<template>
  <div
      :id="random_id"
      :data-testid="props.dataTestid"
      v-if="props.data && props.data.length > 0"
  >
    <TsCarousel v-bind="$attrs"
                :breakpoints="props.breakpoints"
                :navigation="false"
                :pagination="pagination"
                :wrap-around="props.wrapAround"
                :mouse-drag="props.mouseDrag"
                :items-to-show="isMobile ? 1 : 3"
    >
      <Slide v-for="(item, index) in props.data" :key="item.productId">
        <TsProductBanner
            :data-testid="`${props.dataTestid}-product-banner-${index}`"
            :productId="item.productId"
            :backgroundImage="item.backgroundImage"
            :buttonLabel="item.buttonLabel"
            :offer="item.offer"
            :offerType="item.offerType"
            :packSize="item.packSize"
            :title="item.title"
            :description="item.description"
        />
      </Slide>
    </TsCarousel>
  </div>
</template>

<script setup lang="ts">
const TsCarousel = defineAsyncComponent(
    () => import('~/components/organisms/TsCarousel.vue')
);

const TsProductBanner = defineAsyncComponent(
    () => import('~/components/organisms/TsProductBanner.vue')
);

const {isMobile, isTablet, isDesktop} = useDevice();

defineOptions({
  inheritAttrs: false,
});

type Props = {
  dataTestid?: string;
  appendClass?: string;
  breakpoints?: object;
  wrapAround?: boolean;
  mouseDrag?: boolean;
  data?: object[];
};

const props = withDefaults(defineProps<Props>(), {
  wrapAround: false,
  mouseDrag: false,
  breakpoints: () => ({
    0: {
      itemsToShow: 1,
      snapAlign: "center"
    },
    640: {
      itemsToShow: 2,
      snapAlign: "center"
    },
    1024: {
      itemsToShow: 3,
      snapAlign: "center"
    }
  }),
  data: () => ([
    {
      productId: '29688',
      backgroundImage: {
        url: '/images/poc-banner-1.webp',
        width: '600',
        height: '400'
      },
      buttonLabel: 'Shop now',
      offer: '2+1',
      offerType: 'GRATIS',
      packSize: '3 stucks',
      title: 'FM310 MULTI FOAM PRO',
      description: 'pistoolschuim 750ml'
    },
    {
      productId: '50592',
      backgroundImage: {
        url: '/images/poc-banner-2.webp',
        width: '600',
        height: '400'
      },
      buttonLabel: 'Shop now',
      offer: '3+1',
      offerType: 'GRATIS',
      packSize: '3 stucks',
      title: 'FM310 MULTI FOAM PRO',
      description: 'pistoolschuim 750ml'
    },
    {
      productId: '30581',
      backgroundImage: {
        url: '/images/poc-banner-3.webp',
        width: '600',
        height: '400'
      },
      buttonLabel: 'Shop now',
      offer: '1+1',
      offerType: 'GRATIS',
      packSize: '3 stucks',
      title: 'FM310 MULTI FOAM PRO',
      description: 'pistoolschuim 750ml'
    }
  ])
});

const random_id = ref("");

const pagination = computed(() => {
  return !!(isMobile || isTablet);
})

onMounted(() => {
  random_id.value = useRandomUUID();
});
</script>
